// extracted by mini-css-extract-plugin
export default {"wrapper":"MapPOIS_wrapper__L2Z8v","map_title_style":"MapPOIS_map_title_style__b2caS"};